// extracted by mini-css-extract-plugin
export default {"loading":"GkYReu5KASzNdsMAUWQqgg=="};